<template>
<svg viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-Complete`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M36.5528 36.5528C33.0843 40.0213 28.2926 42.1666 22.9999 42.1666C17.7072 42.1666 12.9156 40.0213 9.44703 36.5528C5.97856 33.0843 3.83325 28.2926 3.83325 22.9999C3.83325 17.7072 5.97856 12.9156 9.44703 9.44703C12.9156 5.97856 17.7072 3.83325 22.9999 3.83325C28.2926 3.83325 33.0843 5.97856 36.5528 9.44703C40.0213 12.9156 42.1666 17.7072 42.1666 22.9999C42.1666 28.2926 40.0213 33.0843 36.5528 36.5528ZM30.8166 16.5272C31.5195 15.8243 32.6592 15.8243 33.3622 16.5272C34.0651 17.2302 34.0651 18.3698 33.3622 19.0728L22.3367 30.0983C21.6338 30.8012 20.4941 30.8012 19.7911 30.0983C19.7406 30.0477 19.6937 29.995 19.6505 29.9403C19.5866 29.8916 19.5252 29.8381 19.4669 29.7798L13.5272 23.8401C12.8243 23.1371 12.8243 21.9974 13.5272 21.2945C14.2302 20.5915 15.3698 20.5915 16.0728 21.2945L21.0611 26.2827L30.8166 16.5272Z" :fill="useCurrentColor ? 'currentColor' : '#333'"/></svg>
</template>
<script>

export default {
  name: 'IconComplete',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
